import {useMemo, useState} from 'react'
import * as React from 'react'

import {getDraft} from '../../../../../../../EditPipelinePage/EditPipelinePage.selectors'
import {usePipelineId} from '../../../../../../../hooks/pipeline'
import {EditButton} from '../../../../../EditButton/EditButton'

import BranchSettingsForm from './BranchSettingsForm/BranchSettingsForm'

import styles from './BranchSettings.css'

import SvgIcon from 'src/components/common/SvgIcon/SvgIcon'
import {useAppSelector} from 'src/hooks/react-redux'
import {notNull} from 'src/utils/guards'

const includeRE = /^\+:refs\/heads\/\((.*)\)$/
const excludeRE = /^-:refs\/heads\/\((.*)\)$/

const getJoinedMatches = (lines: string[], re: RegExp) =>
  lines
    .map(line => line.match(re)?.[1])
    .filter(notNull)
    .join(',')

function BranchSettings() {
  const id = usePipelineId()
  const branchSpec = useAppSelector(state => getDraft(state, id)?.vcsRoot.branchSpecification ?? '')
  const {included, excluded} = useMemo(() => {
    const lines = branchSpec.split('\n')
    return {
      included: getJoinedMatches(lines, includeRE),
      excluded: getJoinedMatches(lines, excludeRE),
    }
  }, [branchSpec])
  const defaultBranch = useAppSelector(state => getDraft(state, id)?.vcsRoot.branch ?? '')

  const [isEditing, setIsEditing] = useState(false)

  return !isEditing ? (
    <div role="presentation" className={styles.container} onClick={() => setIsEditing(true)}>
      <SvgIcon icon={'branches'} />
      <div>
        <div className={styles.defaultBranch}>
          <span>{defaultBranch}</span>
          <EditButton iconClassName={styles.editButtonIcon} className={styles.edit} />
        </div>
        <div className={styles.branchRules}>
          {included
            ? `Included branches: ${included}${excluded ? `, excluded: ${excluded}` : ''}`
            : excluded
            ? `Excluded branches: ${excluded}`
            : 'All branches included'}
        </div>
      </div>
    </div>
  ) : (
    <BranchSettingsForm
      included={included}
      excluded={excluded}
      onClose={() => setIsEditing(false)}
    />
  )
}

export default BranchSettings
